import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Historikk from "../../Common/Detalj/Historikk";
import Kommentar from "../../Common/Detalj/Kommentar";

import {
    createIleggelseKommentar,
    getAllIleggelseKommentarer,
} from "../../../actions/IleggelseKommentarerAction";
import { getIleggelseHistorikk } from "../../../actions/ileggelserActions";
import {
    IsValidated,
    onChangeValidation,
} from "../../../utils/validationUtils";

const rules = { kommentarTextarea: "required" };

export default function HistorikkOgKommentarerContainer({ ileggelseId }) {
  const dispatch = useDispatch();
  const ileggelseHistorikk = useSelector((state) =>
    Array.isArray(state.ileggelseHistorikk)
      ? state.ileggelseHistorikk.map((ih) => ({
          historikkBrukerNavn: ih.brukerNavn,
          historikkTidspunkt: ih.tidspunkt,
          felter: ih.endringer,
        }))
      : []
  );
  const ileggelseKommentarer = useSelector(
    (state) => state.ileggelseKommentarer
  );

  const [showKommentarTextarea, setShowKommentarTextarea] = useState(false);
  const [kommentarTextarea, setKommentarTextarea] = useState("");
  const [validationError, setValidationError] = useState({});

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    dispatch(getIleggelseHistorikk(ileggelseId));
    dispatch(getAllIleggelseKommentarer(ileggelseId));
  }, []);

  function handleChange(e) {
    setKommentarTextarea(e.target.value);
    onChangeValidation(e, { kommentarTextarea, validationError }, rules);
  }

  function handleClick(e) {
    if (e.target.name === "showKommentarTextarea") {
      setShowKommentarTextarea(true);
    }
    if (e.target.name === "cancelKommentarTextarea") {
      setShowKommentarTextarea(false);
      setKommentarTextarea("");
      setValidationError({});
    }
  }

  function isValid() {
    const { isValid: valid, validationError: errors } = IsValidated(
      { kommentarTextarea, validationError: {} },
      rules
    );
    setValidationError(errors);
    return valid;
  }

  function handleSubmit(e) {
    e.preventDefault();
    const payload = { tekst: kommentarTextarea };
    if (isValid()) {
      dispatch(createIleggelseKommentar(ileggelseId, payload)).then(() => {
        dispatch(getAllIleggelseKommentarer(ileggelseId));
        setKommentarTextarea("");
      });
    }
  }

  return (
    <section className="detalj-ileggelse-historikk-section-margin no-print">
      <Tabs
        defaultActiveKey={1}
        id="tabs-kommentarer-og-historikk-for-ileggelse"
      >
        <Tab eventKey={1} title="Kommentarer">
          <Kommentar
            kommentarer={ileggelseKommentarer}
            showKommentarTextarea={showKommentarTextarea}
            kommentarTextarea={kommentarTextarea}
            validationError={validationError}
            handleChange={handleChange}
            handleClick={handleClick}
            handleSubmit={handleSubmit}
          />
        </Tab>
        <Tab eventKey={2} title="Historikk">
          <div>
            <Historikk historikkArray={ileggelseHistorikk} />
          </div>
        </Tab>
      </Tabs>
    </section>
  );
}
